module.exports = __webpack_public_path__ + "static/media/futura_light_italic.611a4818.woff2";